import { extendTheme } from "@chakra-ui/react";
import "@fontsource-variable/inter";

const theme = extendTheme({
  fonts: {
    heading: `'HumanSans', sans-serif`,
    body: `'HumanSans', sans-serif`,
  },
});

export default theme;
